import {useUser} from "../../../Context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultRow from "../../Table/ResultRow";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import CheckCSName from "../../CheckCSName";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultView from "../../V2/ResultView";

export function FL1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FL01_FL03.error_id: {
            return (
                <>
                    <ResultText>
                        Flow changes with more than {settings?.thresholds?.flow_change_rate}% are highlighted in the flow table.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15)}}></ResultHeaderCell>
                                <ResultHeaderCell colSpan={row?.profiles?.length} style={{width: HecRasHelper.getWidth(row?.profiles?.length*10), textAlign: 'center'}}>Flow Rate Change (%)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                {
                                    row?.profiles?.map(p => (
                                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(8), textAlign: 'start'}}>{p}</ResultHeaderCell>
                                    ))
                                }
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        {
                                            r?.flow_changes?.map(fc => (
                                                <ResultBodyCell style={{color: Math.abs(fc?.flow_change) > settings?.thresholds?.flow_change_rate ? 'red': '', textAlign: 'start'}}>
                                                    {fc?.flow_change}
                                                </ResultBodyCell>
                                            ))
                                        }
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}